// The help entries, keyed "<section>.<setting>" (e.g. "contrast.n_staircases"):
// help/contrast.tsx, help/acuity.tsx, help/look.tsx (look, edge jitter, timing) and
// help/program.tsx (programs, a patient's programs, home requirements).

import { ACUITY_HELP } from "./acuity";
import { CONTRAST_HELP } from "./contrast";
import { LOOK_HELP } from "./look";
import { PROGRAM_HELP } from "./program";
import type { HelpEntry } from "./types";

export const HELP: Record<string, HelpEntry> = { ...CONTRAST_HELP, ...ACUITY_HELP, ...LOOK_HELP, ...PROGRAM_HELP };
